export default {
  ltr: 'text-left',
  rtl: 'text-right',
  paragraph: 'text-regular mb-2',
  quote: 'text-regular text-text-light',
  heading: {
    h1: 'text-heading2 mb-4 mt-1',
    h2: 'text-heading3 mb-2',
    h3: 'text-regular font-medium mb-1',
    h4: 'text-regular',
    h5: 'text-small'
  },
  list: {
    nested: {
      listitem: 'pl-4 list-none'
    },
    ol: 'list-decimal list-inside my-2',
    ul: 'list-disc list-inside my-2'
  },
  link: 'text-info underline',
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    underlineStrikethrough: '[text-decoration:underline_line-through]'
  }
}
